<template>
  <div>
    <v-container fluid>
      <v-card class="v-card--material pt-2 ma-1 rounded-lg" elevation="2">
        <v-row class="my-1">
          <v-col cols="8" lg="8" md="8" sm="8" xs="8">
            <div class="ml-2">
              <div
                class="font-weight-regular headline text-decoration-underline text-capitalize"
              >
                <span>Day Glance Resources</span>
              </div>
            </div>
          </v-col>
        </v-row>
        <card-component>
          <div>
            <div class="level-left"></div>
            <div class="level-right">
              <div v-if="CurriculumAdmin || isSuperAdmin">
                <div v-if="uploadResources && !lessonFlag" class="level-item">
                  <v-btn
                    v-if="lessionGuide.length === 0"
                    title="Upload Lesson Guide"
                    @click="
                      () => {
                        ;(isUploadResources = false),
                          modalOpen(lessonType),
                          (dropFile = null)
                      }
                    "
                    elevation="1"
                    top
                    color="accent"
                  >
                    <v-icon left>mdi-plus</v-icon>Add Lesson Guide
                  </v-btn>
                </div>
              </div>
              <div v-if="CurriculumAdmin || isSuperAdmin" class="level-item">
                <v-btn v-if="uploadResources"
                  title="Upload Resource Content"
                  @click="
                    () => {
                      ;(isUploadLesson = false),
                        (this.fileList = []),
                        (selectedFiles = []),
                        modalOpen(resourceType)
                    }
                  "
                  elevation="1"
                  top
                  color="accent"
                >
                  <v-icon left>mdi-plus</v-icon>Add Resources
                </v-btn>
              </div>
            </div>
            <v-container>
              <v-row>
                <v-col cols="12" md="12" lg="12" sm="12" xs="12">
                  <v-subheader class="text-h6 pl-0">
                    <v-icon color="primary" elevation="1" left
                      >mdi-library-books</v-icon
                    >
                    <span>LESSON GUIDE</span>
                  </v-subheader>
                  <v-row>
                    <v-col
                      cols="12"
                      md="3"
                      lg="3"
                      xs="6"
                      sm="4"
                      v-for="item in lessonGuide"
                      :key="item.id"
                    >
                      <v-card class="mx-auto" elevation="5">
                        <v-card-title class="py-1">
                          <v-icon color="primary" left>mdi-file-pdf</v-icon>
                          <v-spacer></v-spacer>
                          <div v-if="CurriculumAdmin || isSuperAdmin">
                            <v-btn
                              v-if="uploadResources"
                              @click="deleteResource(item.id)"
                              color="error"
                              icon
                            >
                              <v-icon small>mdi-delete</v-icon>
                            </v-btn>
                          </div>
                        </v-card-title>
                        <v-card-text
                          style="height: 60px"
                          class="py-1 text-subtitle-1"
                        >
                          <span>{{ item.fileName }}</span>
                        </v-card-text>
                        <v-card-actions>
                          <router-link
                            :to="{
                              name: 'previewMedia',
                              params: { previewId: item.id }
                            }"
                            title="Event Calendar"
                          >
                            <v-btn text color="primary" small>
                              <v-icon>mdi-eye</v-icon> View
                            </v-btn>
                          </router-link>
                          <div v-if="CurriculumAdmin || isSuperAdmin">
                            <v-btn
                              text
                              color="primary"
                              small
                              v-if="item.isDownloadable"
                              @click="downloadResource(item.id)"
                            >
                              <v-icon>mdi-arrow-down-bold</v-icon> Download
                            </v-btn>
                          </div>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                    <v-col v-show="!lessonFlag" cols="12">
                      <p class="text-left">No lesson guide available</p>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="12" lg="12" sm="12" xs="12">
                  <v-subheader class="text-h6 pl-0">
                    <v-icon color="primary" elevation="1" left
                      >mdi-library-books</v-icon
                    >
                    <span>RESOURCE FILES</span>
                  </v-subheader>
                  <v-row>
                    <v-col
                      cols="12"
                      md="3"
                      lg="3"
                      xs="6"
                      sm="4"
                      v-for="item in procedure"
                      :key="item.id"
                    >
                      <v-card class="mx-auto" elevation="5">
                        <v-card-title class="py-1">
                          <v-icon color="primary" left>mdi-file-pdf</v-icon>
                          <v-spacer></v-spacer>
                          <div v-if="CurriculumAdmin || isSuperAdmin">
                            <v-btn
                              v-if="uploadResources"
                              @click="deleteResource(item.id)"
                              color="error"
                              icon
                            >
                              <v-icon small>mdi-delete</v-icon>
                            </v-btn>
                          </div>
                        </v-card-title>
                        <v-card-text
                          style="height: 60px"
                          class="py-2 text-subtitle-1"
                        >
                          <span>{{ item.fileName }}</span>
                        </v-card-text>
                        <v-card-actions>
                          <router-link
                            :to="{
                              name: 'previewMedia',
                              params: { previewId: item.id }
                            }"
                            title="Event Calendar"
                          >
                            <v-btn text color="primary" small>
                              <v-icon>mdi-eye</v-icon> View
                            </v-btn>
                          </router-link>
                          <div v-if="CurriculumAdmin || isSuperAdmin">
                            <v-btn
                              text
                              color="primary"
                              small
                              v-if="item.isDownloadable"
                              @click="downloadResource(item.id)"
                            >
                              <v-icon>mdi-arrow-down-bold</v-icon> Download
                            </v-btn>
                          </div>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                    <v-col cols="12" v-show="!procedureFlag">
                      <p class="text-left">No resource file available</p>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </div>
          <hr v-if="!isMain" />
        </card-component>
      </v-card>
    </v-container>
    <v-dialog
      v-model="lessonDialog"
      width="600px"
      :on-cancel="
        () => {
          ;(lessonDialog = false), (dropFile = [])
        }
      "
    >
      <div v-if="isUploadLesson">
        <form @submit.prevent="uploadLesson">
          <v-card>
            <v-toolbar dark color="darkblue" v-if="isUploadLesson">
              <v-toolbar-title>Add Lesson Guide</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <div class="field">
                <v-file-input
                  :label="'Lesson Guide'"
                  v-model="dropFile"
                  chips
                  :accept="allowedFiles"
                  truncate-length="15"
                ></v-file-input>
                <br />
                <br />
                <span class="has-text-danger"
                  >Allowed file's: .pdf, .mov, .mpg, .avi, .mp4,.mp3
                  .wmv,.m4v,.jpg, .png, .jpeg</span
                ><br />
                <span class="has-text-danger"
                  >File's that are not supported will be removed
                  automatically!</span
                >
              </div>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn
                @click="
                  () => {
                    ;(lessonDialog = false), (dropFile = null)
                  }
                "
              >
                Close</v-btn
              >
              <v-btn color="primary" type="submit">Upload</v-btn>
            </v-card-actions>
          </v-card>
        </form>
      </div>
    </v-dialog>

    <v-dialog
      v-model="resourceDialog"
      width="600px"
      :on-cancel="
        () => {
          uploadResourceInputsClear()
        }
      "
    >
      <div v-if="isUploadResources">
        <form @submit.prevent="uploadResource">
          <v-card>
            <v-toolbar dark color="darkblue" v-if="isUploadResources">
              <v-toolbar-title> Upload Resources </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <div class="field">
                <v-file-input
                  v-model="selectedFiles"
                  label="Select files..."
                  multiple
                  @change="updateDataTable"
                  :accept="allowedFiles"
                ></v-file-input>
                <v-chip-group v-model="selectedFiles" active-class="primary">
                  <v-chip
                    v-for="(file, index) in selectedFiles"
                    :key="index"
                    disabled
                  >
                    {{ file.name }}
                  </v-chip>
                </v-chip-group>
                <br />
              </div>
              <span class="has-text-danger"
                >Allowed file's: .pdf, .mov, .mpg, .mp3, .avi, .mp4,
                .wmv,.m4v,.jpg, .png, .jpeg</span
              ><br />
              <span class="has-text-danger"
                >File's that are not supported will be removed
                automatically!</span
              >
              <v-data-table
                :headers="headers"
                :items="fileList"
                hide-default-footer
              >
                <template v-slot:item.index="{ item }">
                  {{ item.index }}
                </template>
                <template v-slot:item.downloadable="{ item }">
                  <v-checkbox v-model="item.downloadable"></v-checkbox>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-btn icon @click="removeFile(item.index)">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn
                @click="
                  () => {
                    ;(resourceDialog = false), (files = [])
                  }
                "
              >
                Close</v-btn
              >
              <v-btn color="primary" type="submit">Upload Resource</v-btn>
            </v-card-actions>
          </v-card>
        </form>
      </div>
    </v-dialog>

    <loading-icon :value="isLoading" />
  </div>
</template>
<script>
// import MaterialCard from '@/components/template/MaterialCard'
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import Utils from '@/utils'
import stores from '@/stores'

export default {
  name: 'dayGlanceResources',
  components: {
    CardComponent
    // MaterialCard
  },
  props: ['themeID'],
  data () {
    return {
      valid: true,
      dialog: false,
      academicYears: [],
      lessonType: 'LESSON',
      resourceType: 'RESOURCE',
      selectedClassID: null,
      isLoading: true,
      franchiseeID: '',
      academicYearID: '',
      isMain: true,
      isUploadLesson: false,
      isUploadResources: false,
      fileName: '',
      dropFile: null,
      inputTitle: "Select file('s)",
      files: [],
      isWrite: false,
      allowedFiles: [
        '.pdf, .mov, .mpg, .avi, .mp4, .mp3 .wmv,.m4v,.jpg, .png, .jpeg',
        'ppt',
        'pptx'
      ],
      isActive: true,
      lessionGuide: [],
      search: '',
      success: '',
      editModalOk: false,
      previousFiles: [],
      isDownloadable: false,
      selectedFiles: [],
      fileList: [],
      headers: [
        { text: 'Index', value: 'index' },
        { text: 'Name', value: 'name' },
        { text: 'Downloadable', value: 'downloadable', align: 'center' },
        { text: 'Actions', value: 'actions' }
      ],
      lessonGuide: [],
      procedure: [],
      procedureFlag: false,
      lessonFlag: false,
      lessonDialog: false,
      resourceDialog: false,
      uploadResources: false,
      CurriculumAdmin: false
    }
  },
  async created () {
    if (stores.user.me.superAdmin === false) {
      for (const item of stores.user.roles) {
        if (item.role === 'CurriculumAdmin') {
          this.CurriculumAdmin = true
        }
      }
    }
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    this.uploadResources = this.checkModuleAccess('uploadResources')
    await this.getResources()
  },
  mounted: async function () {},
  watch: {
    files (val) {
      this.previousFiles = val
    }
  },
  computed: {
    isSuperAdmin: function () {
      return stores.user.me.superAdmin
    }
  },
  methods: {
    updateDataTable () {
      this.fileList = this.selectedFiles.map((file, index) => ({
        index: index + 1,
        name: file.name,
        downloadable: false
      }))
    },
    removeFile (index) {
      const fileIndex = this.fileList.findIndex((file) => file.index === index)
      if (fileIndex !== -1) {
        this.fileList.splice(fileIndex, 1)
        this.fileList.forEach((file, index) => {
          file.index = index + 1
        })
        this.selectedFiles.splice(fileIndex, 1)
      }
    },
    remove (index) {
      this.files.splice(index, 1)
    },
    fileAdded () {
      if (this.previousFiles.length > 0) {
        this.files.push(...this.previousFiles)
      }
    },
    closeEdit: async function () {
      this.editModalOk = false
    },

    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    fileOpen: async function (path) {
      try {
        this.isLoading = true
        let url = await http.get(
          `${constants.API_URL}/api/staff/downloadurl?s3urlKey=${path}`
        )
        window.open(url.data)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting file details, ${errorMessage}`)
      } finally {
        this.isLoading = false
      }
    },
    uploadLesson: async function () {
      try {
        this.isLoading = true
        let formData = new FormData()
        formData.append('isDownloadable', false)
        formData.append('file', this.dropFile)
        await http.post(
          `${constants.API_URL}/api/curriculum_cms/lesson-guide/${this.themeID}`,
          formData
        )
        this.lessonDialog = false
        this.resourceDialog = false
        // this.uploadInputsClear()
        this.okMsg('Lesson Uploaded Successfully!')
        this.getResources()
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While uploading document: ${errorMessage}`)
      } finally {
        this.isLoading = false
      }
    },
    uploadResource: async function () {
      try {
        this.isLoading = true
        let formData = new FormData()
        const fileData = this.fileList.map((file) => ({
          fileName: file.name,
          isDownloadable: file.downloadable
        }))
        for (let i in this.selectedFiles) {
          formData.append('files', this.selectedFiles[i])
        }
        formData.append('fileData', JSON.stringify(fileData))

        await http.post(
          `${constants.API_URL}/api/curriculum_cms/add-document/${this.themeID}`,
          formData
        )

        this.lessonDialog = false
        this.resourceDialog = false
        // this.uploadInputsClear()
        this.okMsg('Resource Uploaded Successfully!')
        this.getResources()
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While uploading document: ${errorMessage}`)
      } finally {
        this.isLoading = false
      }
    },

    modalOpen (type) {
      this.lessonDialog = false
      this.resourceDialog = false
      this.isUploadLesson = false
      this.isUploadResources = false

      if (type === this.lessonType) {
        this.isUploadLesson = true
        this.lessonDialog = true
      } else {
        this.isUploadResources = true
        this.resourceDialog = true
      }
    },

    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    getResources: async function () {
      try {
        this.lessonGuide = []
        this.procedure = []
        this.procedureFlag = false
        this.lessonFlag = false
        let res = await http.get(
          `${constants.API_URL}/api/curriculum_cms/get-resources/${this.themeID}`
        )
        if (res.status === 200 && res.data.length > 0) {
          res.data.forEach((item) => {
            if (item.section === 'LESSON GUIDE') {
              this.lessonGuide.push(item)
            } else if (item.section === 'RESOURCE CONTENT') {
              this.procedure.push(item)
            }
          })
          this.lessonFlag = this.lessonGuide.length > 0
          this.procedureFlag = this.procedure.length > 0
        } else {
          return this.$dialog.error({
            text: 'No data available',
            title: 'Error'
          })
        }
      } catch (e) {
        return this.$dialog.error({
          text: e.response.data.message,
          title: 'Error'
        })
      }
    },
    downloadResource: async function (resID) {
      try {
        let res = await http.get(
          `${constants.API_URL}/api/curriculum_cms/get-signed-url/${resID}`
        )
        if (res.status === 200) {
          window.open(res.data.filePath)
        } else {
          return this.$dialog.error({
            text: 'Failed to open file.',
            title: 'Error'
          })
        }
      } catch (e) {
        return this.$dialog.error({
          text: e.response.data.message,
          title: 'Error'
        })
      }
    },
    deleteResource: async function (resID) {
      try {
        let res = await http.put(
          `${constants.API_URL}/api/curriculum_cms/in-active-file/${resID}`
        )
        if (res.status === 200) {
          this.$dialog.message.info('File deleted sccessfully.', {
            position: 'top-center',
            color: 'success',
            timeout: 4000
          })
          this.getResources()
        } else {
          this.$dialog.message.error('Failed to delete file.', {
            position: 'top-center',
            color: 'error',
            timeout: 4000
          })
        }
      } catch (e) {
        this.$dialog.message.error(e.response.data.message, {
          position: 'top-center',
          color: 'error',
          timeout: 4000
        })
      }
    }
  }
}
</script>
<style scoped>
.tile.is-child {
  border: 1px solid #ff000059;
}
.fol-name {
  overflow-wrap: break-word;
}
.foldr {
  cursor: pointer;
}
.islink {
  cursor: pointer;
}
.isBlueLink {
  color: #0d6efd;
  text-decoration: underline;
}
.shortFoldername {
  width: 155px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.shortFoldername:hover {
  overflow: visible;
  white-space: normal;
  width: auto;
  position: absolute;
  background-color: #fff;
}
</style>
